import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateChannel {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/NewSubscription.js